import { render, staticRenderFns } from "./CompaniesProjectsTable.vue?vue&type=template&id=3d4d6bc3"
import script from "./CompaniesProjectsTable.vue?vue&type=script&lang=js"
export * from "./CompaniesProjectsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports